import Service from "../Service";
import axios from "axios";
import { domain } from "../Constants";

const portfolio = {
  getAllPortfolioByMemberId(id) {
    return axios({
      url: `${domain}api/portfolio?profile_id=${id}`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error on get all portfolio\n", e.message);
      return { status: e.response.status };
    });
  },

  getPortfolio(id) {
    return axios({
      url: `${domain}api/portfolio/${id}`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error on get portfolio\n", e.message);
      return { status: e.response.status };
    });
  },

  previewPortfolioDetailByMemberId(payload) {
    return axios({
      url: `${domain}api/preview-portfolio/${payload.id}?profile_id=${payload.profile_id}`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error on get preview portfolio\n", e.message);
      return { status: e.response.status };
    });
  },

  createPortfolio(data, profile_id) {
    // filter empty array index
    if (data.portfolio_image.length > 0) {
      data.portfolio_image = data.portfolio_image.filter((item) => {
        if (item.img_path) {
          return item;
        }
      });
    }
    return axios({
      url: `${domain}api/portfolio`,
      method: "POST",
      data: { ...data, ...profile_id },
    }).catch((e) => {
      console.log("Catch error on create portfolio\n", e.message);
      return { status: e.response.status };
    });
  },

  editPortfolio(data, profile_id) {
    // filter empty array index
    // if (data.moreImages.length > 0) {
    //     data.moreImages = data.moreImages.filter(item => {
    //         if (item.image) {
    //             return item;
    //         }
    //     });
    // }
    if (data.portfolio_image.length > 0) {
      data.portfolio_image = data.portfolio_image.filter((item) => {
        if (item.img_path) {
          return item;
        }
      });
    }
    return axios({
      url: `${domain}api/portfolio/${data.portfolio_id}`,
      method: "PUT",
      data: { ...data, ...profile_id },
    }).catch((e) => {
      console.log("Catch error on edit portfolio\n", e.message);
      return { status: e.response.status };
    });
  },

  deletePortfolio(id) {
    return axios({
      url: `${domain}api/portfolio/${id}`,
      method: "DELETE",
    }).catch((e) => {
      console.log("Catch error on delete portfolio\n", e.message);
      return { status: e.response.status };
    });
  },

  getCategory() {
    return axios({
      url: `${domain}api/category`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error on get category\n", e.message);
      return { status: e.response.status };
    });
  },

  onGetCategoryList() {
    return axios({
      url: `${domain}api/get-category-list`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error on get category\n", e.message);
      return { status: e.response.status };
    });
  },

  getSubCategory() {
    return axios({
      url: `${domain}api/subcategory`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error on get subcategory\n", e.message);
      return { status: e.response.status };
    });
  },

  getPortfolioDetailByMemberId(id) {
    return axios({
      url: `${domain}api/portfolio?profile_id=` + id,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error on get portfolio detail\n", e.message);
      return { status: e.response.status };
    });
  },

  getMostViewPortfolio() {
    return axios({
      url: `${domain}api/get-most-view-portfolio`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error on get most view portfolio\n", e.message);
      return { status: e.response.status };
    });
  },

  getNewPortfolio() {
    return axios({
      url: `${domain}api/get-new-portfolio`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error on get new portfolio\n", e.message);
      return { status: e.response.status };
    });
  },

  getPortfolioByIdCategory(data) {
    return axios({
      url: `${domain}api/get-portfolio-by-id-category?page=${data.page}&id=${data.id}`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error on get new portfolio\n", e.message);
      return { status: e.response.status };
    });
  },

  getPortfolioByIdTag(data) {
    return axios({
      url: `${domain}api/get-portfolio-by-id-tag?page=${data.page}&id=${data.id}`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error on get new portfolio\n", e.message);
      return { status: e.response.status };
    });
  },

  getPortfolioBySearch(data) {
    return axios({
      url: `${domain}api/search?page=${data.page}&keyword=${data.keyword}`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error on search portfolio\n", e.message);
      return { status: e.response.status };
    });
  },

  getPortfolioDesign(data) {
    return axios({
      url: `${domain}api/get-portfolio-design?page=${data.page}&profile_id=${data.profile_id}&category_id=${data.category_id}&subcategory_id=${data.subcategory_id}`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error on get portfolio by design\n", e.message);
      return { status: e.response.status };
    });
  },

  getPortfolioByCategoryIdAndMemberId(data) {
    return axios({
      url: `${domain}api/get-portfolio-by-categoryid-memberid?page=${data.page}&category_id=${data.category_id}&profile_id=${data.profile_id}`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error on get new portfolio\n", e.message);
      return { status: e.response.status };
    });
  },

  getPortfolioBySubCategoryIdAndMemberId(data) {
    return axios({
      url: `${domain}api/get-portfolio-by-subcategoryid-memberid?page=${data.page}&category_id=${data.category_id}&profile_id=${data.profile_id}&subcategory_id=${data.subcategory_id}`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error on get new portfolio\n", e.message);
      return { status: e.response.status };
    });
  },

  getPortfolioByIdSubCategory(data) {
    return axios({
      url: `${domain}api/get-portfolio-by-id-subcategory?page=${data.page}&category_id=${data.category_id}&subcategory_id=${data.subcategory_id}`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error on get portfolio by sub category\n", e.message);
      return { status: e.response.status };
    });
  },

  getPortfolioByDesign(data) {
    return axios({
      url: `${domain}api/get-portfolio-by-design?page=${data.page}&profile_id=${data.profile_id}&category_id=${data.category_id}`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error on get portfolio by design\n", e.message);
      return { status: e.response.status };
    });
  },

  saveView(id) {
    let data = { id: id };
    return Service.post("api/save-view", data);
  },

  shareFacebook(id) {
    return Service.get(`api/share-facebook/${id}`);
  },

  getMostDesignPortfolio() {
    return Service.get("api/get-most-design-portfolio");
  },

  search(data) {
    return Service.get(`api/search?page=${data.page}&keyword=${data.keyword}`);
  },
  getTopRank(data) {
    return Service.get(
      `api/get-toprank?category_id=${data.category_id}&sort=${data.sort}`
    );
  },
  getSortTopRank(data) {
    return Service.get(
      `api/get-sort-toprank?category_id=${data.category_id}&sort=${data.sort}`
    );
  },
  getToprankHomepage(data) {
    return Service.get(`api/get-toprank-homepage?sort=${data}`);
  },
  getProfilePortfolio(data) {
    return Service.get(
      `api/get-profile-portfolio?page=${data.page}&id=${data.id}`
    );
  },
  getOrtherPortfolios(data) {
    return Service.get(
      `api/get-orther-portfolios?portfolio_id=${data.portfolio_id}&profile_id=${data.profile_id}`
    );
  },
};

export default portfolio;
